// import { Item, ExtensionFilterProps } from '../../../types/types';

// const ExtensionFilter: React.FC<ExtensionFilterProps> = ({
//   className,
//   items,
//   activeIndex,
// }) => {
//   return (
//     <>
//       <ul className={className}>
//         {items.map((item: Item, index: number) => (
//           <li
//             key={item.id}
//             className={`${className}__item ${
//               index === activeIndex ? 'active' : ''
//             }`}
//           >
//             <p className={`${className}__text text-micro`}>{item.text}</p>
//           </li>
//         ))}
//       </ul>
//     </>
//   );
// };
// export default ExtensionFilter;
import { Item, ExtensionFilterProps } from '../../../types/types';

const ExtensionFilter: React.FC<ExtensionFilterProps> = ({
  className,
  onClick,
  items,
}) => {
  return (
    <>
      <ul className={className}>
        {items.map((item: Item) => (
          <li
            key={item.id}
            className={`${className}__item ${item.default ? 'active' : ''}`}
            onClick={onClick}
          >
            <p className={`${className}__text text-micro`}>{item.text}</p>
          </li>
        ))}
      </ul>
    </>
  );
};
export default ExtensionFilter;
